import { makeStyles } from '@material-ui/core/styles';
import { maxContainerWidth } from './theme';

export const desktopContainer = {
  maxWidth: maxContainerWidth,
  margin: '0 auto',
  width: '100%',
};

export const getScrollbarStyles = () => ({
  '&::-webkit-scrollbar': {
    width: '9px',
    marginLeft: '12px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#0090E5',
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#DAEFFB',
  },
});

export const getCommonStyles = (theme) => ({
  container: {
    ...desktopContainer,
    [theme.breakpoints.down('md')]: {
      padding: '0 80px',
      margin: 'unset',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px',
    },
    [theme.breakpoints.down('lg')]: {
      padding: '0 20px',
    },
  },
  pageWrapper: {
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  expert3Container:{
    maxWidth: maxContainerWidth,
    margin: '0 auto',
    width: '80%',
  }
});

export const useCommonStyles = makeStyles((theme) => getCommonStyles(theme));
